import { SendEmailFieldNames, useSendEmailForm } from 'hooks/forms';
import { lowerCaseTransform } from 'utils';
import Field from 'components/Field';
import { Modal, ModalProps } from 'components/Modal';
import Button from 'components/Button';
import styles from './SpecifyEmailModal.module.css';
import messages from './SpecifyEmailModal.messages';

type Props = {
  onRequestClose: VoidFunction;
  callbackFn: (email: string) => void;
} & ModalProps;

const SpecifyEmailModal = ({
  onRequestClose,
  callbackFn,
  ...props
}: Props): JSX.Element => {
  const {
    form,
    customState: { isCompleted },
  } = useSendEmailForm();

  const onSubmit = (): void => {
    const { email } = form.getValues();
    callbackFn(email);
  };

  const onCancel = (): void => {
    onRequestClose();
    form.reset();
  };

  return (
    <Modal {...props} onRequestClose={onCancel} className={styles.specifyEmailModal}>
      <h3 className={styles.specifyEmailModal__title}>{messages.title}</h3>
      <p className={styles.specifyEmailModal__subtitle}>{messages.subtitle}</p>
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <Field
          form={form}
          name={SendEmailFieldNames.email}
          placeholder={messages.placeholder.email}
          className={styles.specifyEmailModal__input}
          defaultValue={''}
          type={'text'}
          maxLength={256}
          {...lowerCaseTransform}
        />
      </form>
      <div className={styles.specifyEmailModal__buttons}>
        <Button onClick={onCancel} variant={'outline'}>
          {messages.button.cancel}
        </Button>
        <Button onClick={form.handleSubmit(onSubmit)} displayDisabledUI={!isCompleted}>
          {messages.button.next}
        </Button>
      </div>
    </Modal>
  );
};

export default SpecifyEmailModal;
